<style lang="scss" scoped>
header {
  padding: 20px 0px;
  height: 80px;
  background: var(--primary);
  z-index: 1005;
  position: relative;
  .content {
    height: 40px;
    .logo-link {
      display: flex;
      height: 40px;
      align-items: center;
      .logo {
        height: 19px;
      }
      &.custom {
        .logo {
          height: 100%;
        }
      }
    }
  }
}
</style>

<template>
  <header class="navbar row">
    <div class="container">
      <div class="row">
        <div class="col-12 content">
          <div class="row">
            <div class="col-9 col-md-3">
              <router-link class="logo-link" :class="{ custom: workspace.logo && workspace.custom_branding_allowed }" :to="{ name: 'workspace', params: { id: workspace.id } }">
                <img class="logo" v-if="workspace.logo && workspace.custom_branding_allowed" :src="workspace.logo.file_path.default" />
                <i-logo class="logo" v-else-if="!$root.isMobile"></i-logo>
                <i-logo-mobile class="logo" v-else></i-logo-mobile>
              </router-link>
            </div>

            <el-navbar-search v-if="!$root.isMobile" class="col-6" />

            <el-navbar-dropdown class="col-3" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import ElNavbarSearch from '@/components/general/navbar-search';
import ElNavbarDropdown from '@/components/general/navbar-dropdown';
import hexToRgba from 'hex-to-rgba';

export default {
  components: { ElNavbarSearch, ElNavbarDropdown },

  mounted() {
    this.determineWorkspaceColor();
  },

  methods: {
    determineWorkspaceColor() {
      if (this.workspace.color_code && this.workspace.custom_branding_allowed) {
        const root = document.documentElement;
        root.style.setProperty('--primary', this.workspace.color_code);
        root.style.setProperty('--primary-highlight', hexToRgba(this.workspace.color_code, 0.1));
      }
    },
  },

  computed: {
    workspace() {
      return this.$store.getters['workspace/current'];
    },
  },
  watch: {
    'workspace.color_code': function() {
      this.determineWorkspaceColor();
    },
  },
};
</script>
